docReady(function () {
	document.querySelectorAll('.header-v2').forEach(function (header) {
		const burger = header.querySelector('.header-v2__burger');
		const panel = header.querySelector('.header-v2__panel');
		const logo = header.querySelector('.header-v2__logo');
		if (!burger || !panel) return;

		const breakpoint = getComputedStyle(header).getPropertyValue('--header-v2-menu-breakpoint').trim();
		const desktop = window.matchMedia(`(min-width: ${breakpoint})`);
		const items = [...header.querySelectorAll('.header-v2-nav__item--mega')];
		const inertElements = new Map();
		let open = false;
		let scrollPosition = 0;
		let previousBodyTop = '';

		function updateTopState() {
			header.classList.toggle('is-at-top', desktop.matches && !open && window.scrollY <= 0);
		}
		updateTopState();
		window.addEventListener('scroll', updateTopState, { passive: true });

		function setExpanded(item, expanded) {
			item.classList.toggle('is-expanded', expanded);
			item.querySelector(':scope > button').setAttribute('aria-expanded', String(expanded));
		}

		function setOpen(nextOpen, restoreFocus = true) {
			if (open === nextOpen) return;
			open = nextOpen;
			header.classList.toggle('is-open', open);
			if (logo) logo.src = open ? logo.dataset.openSrc : logo.dataset.defaultSrc;
			burger.setAttribute('aria-expanded', String(open));
			burger.setAttribute('aria-label', open ? 'Close navigation' : 'Open navigation');
			items.forEach((item) => setExpanded(item, false));

			if (open) {
				scrollPosition = window.scrollY;
				previousBodyTop = document.body.style.top;
				document.documentElement.classList.add('has-mobile-menu-open');
				document.body.classList.add('has-mobile-menu-open');
				document.body.style.top = `-${scrollPosition}px`;
				// Keep background content out of the keyboard and accessibility navigation.
				let branch = header;
				while (branch.parentElement) {
					[...branch.parentElement.children].forEach((element) => {
						if (element !== branch && !element.contains(header)) {
							inertElements.set(element, element.inert);
							element.inert = true;
						}
					});
					branch = branch.parentElement;
					if (branch === document.body) break;
				}
				panel.querySelector('a, button')?.focus();
			} else {
				inertElements.forEach((inert, element) => { element.inert = inert; });
				inertElements.clear();
				document.documentElement.classList.remove('has-mobile-menu-open');
				document.body.classList.remove('has-mobile-menu-open');
				document.body.style.top = previousBodyTop;
				const scrollBehavior = document.documentElement.style.scrollBehavior;
				document.documentElement.style.scrollBehavior = 'auto';
				window.scrollTo(0, scrollPosition);
				document.documentElement.style.scrollBehavior = scrollBehavior;
				if (restoreFocus) burger.focus({ preventScroll: true });
			}
			updateTopState();
		}

		burger.addEventListener('click', function () {
			if (!desktop.matches) setOpen(!open);
		});

		items.forEach(function (item, index) {
			const trigger = item.querySelector(':scope > button');
			const mega = item.querySelector(':scope > .header-v2-mega');
			if (!trigger || !mega) return;
			mega.id = mega.id || `${panel.id}-mega-${index}`;
			trigger.setAttribute('aria-controls', mega.id);
			trigger.addEventListener('click', function () {
				if (desktop.matches) return;
				const expanded = !item.classList.contains('is-expanded');
				items.forEach((other) => setExpanded(other, other === item && expanded));
			});
			function updateDesktopExpanded() {
				if (desktop.matches) trigger.setAttribute('aria-expanded', String(item.matches(':hover, :focus-within')));
			}
			item.addEventListener('mouseenter', updateDesktopExpanded);
			item.addEventListener('mouseleave', updateDesktopExpanded);
			item.addEventListener('focusin', updateDesktopExpanded);
			item.addEventListener('focusout', () => queueMicrotask(updateDesktopExpanded));
		});

		panel.addEventListener('click', function (event) {
			if (open && event.target.closest('a[href]')) setOpen(false, false);
		});

		header.addEventListener('keydown', function (event) {
			if (!open) return;
			if (event.key === 'Escape') {
				event.preventDefault();
				setOpen(false);
			} else if (event.key === 'Tab') {
				const focusable = [...header.querySelectorAll('a[href], button:not([disabled])')]
					.filter((element) => element.getClientRects().length);
				const first = focusable[0];
				const last = focusable[focusable.length - 1];
				if (event.shiftKey && document.activeElement === first) {
					event.preventDefault();
					last.focus();
				} else if (!event.shiftKey && document.activeElement === last) {
					event.preventDefault();
					first.focus();
				}
			}
		});

		desktop.addEventListener('change', function () {
			setOpen(false, false);
			items.forEach((item) => setExpanded(item, false));
			updateTopState();
		});
	});
});
